import React from 'react';
import clsx from 'clsx';

type Props = {
  children: React.ReactNode;
  placement: 'top' | 'bottom' | 'left' | 'right';
  text: string;
  color?: 'red-100' | 'primary-slate';
};

const index = ({ children, placement, text, color = 'red-100' }: Props) => {
  return (
    <div role="tooltip" className="group relative">
      {children}
      <span
        className={`invisible absolute w-max max-w-[235px] rounded-28 text-center bg-${color} px-16 py-8 text-sm text-white-100 opacity-0 shadow-md transition-opacity after:absolute after:border-8 after:border-${color} group-hover:visible group-hover:opacity-100 ${clsx(
          {
            'bottom-full left-2/4 mb-8 -translate-x-2/4 after:left-2/4 after:top-full after:-translate-x-2/4 after:border-b-transparent after:border-l-transparent after:border-r-transparent':
              placement === 'top',
            'left-2/4 top-full mt-8 -translate-x-2/4 after:bottom-full after:left-2/4 after:-translate-x-2/4 after:border-l-transparent after:border-r-transparent after:border-t-transparent':
              placement === 'bottom',
            'right-full top-2/4 mr-8  -translate-y-2/4 after:left-full after:top-2/4 after:-translate-y-2/4 after:border-b-transparent after:border-r-transparent after:border-t-transparent':
              placement === 'left',
            'left-full top-2/4 ml-8 -translate-y-2/4 after:right-full after:top-2/4 after:-translate-y-2/4 after:border-b-transparent after:border-l-transparent after:border-t-transparent':
              placement === 'right',
          }
        )}`}
      >
        {text}
      </span>
    </div>
  );
};
export default index;
